import { render, staticRenderFns } from "./MyFormPanel.vue?vue&type=template&id=208e9a48&scoped=true&"
import script from "./MyFormPanel.vue?vue&type=script&lang=js&"
export * from "./MyFormPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208e9a48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208e9a48')) {
      api.createRecord('208e9a48', component.options)
    } else {
      api.reload('208e9a48', component.options)
    }
    module.hot.accept("./MyFormPanel.vue?vue&type=template&id=208e9a48&scoped=true&", function () {
      api.rerender('208e9a48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyFormPanel/MyFormPanel.vue"
export default component.exports